module.exports = __webpack_public_path__ + "static/media/ZendyIcon.3c525060.jpg";